/*
 * @Description: ***页面
 * @Date: 2023-11-21 11:33:53
 * @Author: hkr
 * @LastEditors: hkr
 */
import { useState, useEffect } from 'react'

const getDocumentWidth = () => {
  return document.documentElement.getBoundingClientRect().width
}

const isMobileUtil = () => {
  return getDocumentWidth() <= 750
}

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(isMobileUtil())

  useEffect(() => {
    const observeDocument = document.body
    const resizeObserver = new ResizeObserver(entries => {
      setIsMobile(isMobileUtil())
    })
    resizeObserver.observe(observeDocument)
    return () => {
      resizeObserver.unobserve(observeDocument)
    }
  }, [])

  return isMobile === true
}

export default useIsMobile
